import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onlinecabbookingnavimumbaiairport() {



    const cardData = {





keyword: "Online Cab Booking Navi Mumbai Airport",

headingDescription: "Shreesha Tours & Travels provides fast and reliable Online Cab Booking from Navi Mumbai Airport for airport transfers, business travel, corporate transportation, family vacations, hotel transfers, one-way journeys, round trips, and outstation travel across Maharashtra and nearby states. We offer a fleet of chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, Mini Bus, and premium vehicles to suit every travel requirement. With easy online booking, professional drivers, flight tracking, on-time airport pickups, transparent pricing, clean vehicles, doorstep drop service, and 24/7 customer support, we ensure a safe, comfortable, and hassle-free travel experience. Whether you are arriving at Navi Mumbai Airport for business, tourism, family functions, or long-distance travel, Shreesha Tours & Travels offers dependable online airport cab booking services with complete convenience and customer satisfaction.",

topPlaces: [
  {
    title: "Navi Mumbai Airport to Shirdi",
    description: "Shirdi is one of India's most visited pilgrimage destinations, famous for Sai Baba Temple, Dwarkamai, Chavadi, and spiritual attractions, making it a popular airport cab route."
  },
  {
    title: "Navi Mumbai Airport to Mahabaleshwar",
    description: "Mahabaleshwar is a scenic hill station known for Venna Lake, Mapro Garden, Arthur's Seat, strawberry farms, and breathtaking viewpoints."
  },
  {
    title: "Navi Mumbai Airport to Kolhapur",
    description: "Kolhapur is famous for Mahalaxmi Temple, Panhala Fort, Rankala Lake, and authentic Maharashtrian culture, making it a preferred long-distance destination."
  },
  {
    title: "Navi Mumbai Airport to Goa",
    description: "Goa is India's favorite beach destination, offering beautiful beaches, churches, forts, water sports, luxury resorts, and vibrant nightlife."
  },
  {
    title: "Navi Mumbai Airport to Surat",
    description: "Surat is a major commercial city known for its textile and diamond industries, Dumas Beach, and business hubs, making it a popular corporate travel route."
  },
  {
    title: "Navi Mumbai Airport to Vadodara",
    description: "Vadodara is known for Laxmi Vilas Palace, Sayaji Garden, museums, and royal heritage, making it a popular destination for business and family travel."
  },
  {
    title: "Navi Mumbai Airport to Saputara",
    description: "Saputara is Gujarat's only hill station, famous for Saputara Lake, Sunset Point, Ropeway, Gira Waterfalls, and peaceful natural surroundings."
  },
  {
    title: "Navi Mumbai Airport to Ratnagiri",
    description: "Ratnagiri is a scenic Konkan destination famous for Ganpatipule Temple, beaches, sea forts, Alphonso mango orchards, and coastal beauty."
  },
  {
    title: "Navi Mumbai Airport to Aurangabad",
    description: "Aurangabad attracts visitors with Ajanta Caves, Ellora Caves, Grishneshwar Jyotirlinga, Daulatabad Fort, and Bibi Ka Maqbara."
  },
  {
    title: "Navi Mumbai Airport to Hyderabad",
    description: "Hyderabad is a leading business and tourist destination known for Charminar, Ramoji Film City, Golconda Fort, Hussain Sagar Lake, and world-class IT hubs."
  }
],


"services": [
  {
    "name": "Online Cab Booking Navi Mumbai Airport",
    "description": "Book Online Cab Booking Navi Mumbai Airport for fast, secure, and hassle-free airport transportation with instant confirmation. Choose from Sedan, Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, SUV, Tempo Traveller, and luxury vehicles for airport pickup and drop services. Enjoy transparent pricing, professional chauffeurs, flight tracking, luggage assistance, and 24x7 customer support."
  },
  {
    "name": "Navi Mumbai Airport Online Cab Booking",
    "description": "Choose Navi Mumbai Airport Online Cab Booking for convenient airport travel with easy reservations, reliable drivers, and comfortable AC vehicles. Our online booking platform allows you to schedule airport pickups and drops quickly with flexible travel options."
  },
  {
    "name": "Book Cab Online Navi Mumbai Airport",
    "description": "Book Cab Online Navi Mumbai Airport with instant confirmation and multiple vehicle choices for individuals, families, corporate travelers, and groups. Enjoy secure booking, punctual service, and comfortable airport transportation."
  },
  {
    "name": "Navi Mumbai Airport Cab Booking Online",
    "description": "Reserve Navi Mumbai Airport Cab Booking Online for smooth airport transfers with professional chauffeurs, well-maintained vehicles, transparent pricing, and reliable pickup and drop services."
  },
  {
    "name": "Online Taxi Booking Navi Mumbai Airport",
    "description": "Choose Online Taxi Booking Navi Mumbai Airport for affordable and dependable airport transportation with experienced drivers, clean AC taxis, and timely airport pickups available throughout the day."
  },
  {
    "name": "Best Online Cab Booking Navi Mumbai Airport",
    "description": "Book the Best Online Cab Booking Navi Mumbai Airport for premium airport transfer services with experienced chauffeurs, comfortable vehicles, instant booking confirmation, and outstanding customer support."
  },
  {
    "name": "Cheap Online Cab Booking Navi Mumbai Airport",
    "description": "Choose Cheap Online Cab Booking Navi Mumbai Airport for budget-friendly airport transfers with transparent fares, reliable drivers, clean AC vehicles, and quality service without hidden charges."
  },
  {
    "name": "Reliable Online Cab Booking Navi Mumbai Airport",
    "description": "Reserve Reliable Online Cab Booking Navi Mumbai Airport for dependable airport transportation with verified chauffeurs, well-maintained vehicles, punctual pickups, and secure online reservations."
  },
  {
    "name": "Instant Cab Booking Navi Mumbai Airport",
    "description": "Book Instant Cab Booking Navi Mumbai Airport for immediate airport transportation with quick confirmation, fast driver allocation, and comfortable AC vehicles available whenever you need them."
  },
  {
    "name": "Advance Cab Booking Navi Mumbai Airport",
    "description": "Choose Advance Cab Booking Navi Mumbai Airport to schedule your airport pickup or drop in advance. Secure your preferred vehicle and enjoy worry-free airport transportation with timely service."
  },
  {
    "name": "24x7 Online Cab Booking Navi Mumbai Airport",
    "description": "Book 24x7 Online Cab Booking Navi Mumbai Airport for round-the-clock airport transportation. Whether your flight is early morning, late night, or during peak hours, our airport cab services are always available."
  },
  {
    "name": "Late Night Online Cab Booking Navi Mumbai Airport",
    "description": "Reserve Late Night Online Cab Booking Navi Mumbai Airport for safe and secure midnight airport transfers with experienced chauffeurs, clean vehicles, and dependable pickup services."
  },
  {
    "name": "Early Morning Online Cab Booking Navi Mumbai Airport",
    "description": "Book Early Morning Online Cab Booking Navi Mumbai Airport for punctual airport departures with guaranteed on-time pickups, professional drivers, and comfortable AC vehicles."
  },
  {
    "name": "Airport Pickup Online Cab Booking Navi Mumbai",
    "description": "Choose Airport Pickup Online Cab Booking Navi Mumbai for seamless airport arrival transfers with flight tracking, luggage assistance, professional chauffeurs, and comfortable transportation to your destination."
  },
  {
    "name": "Online Airport Transfer Navi Mumbai",
    "description": "Reserve Online Airport Transfer Navi Mumbai for reliable airport pickup and drop services with secure online reservations, premium vehicles, transparent pricing, and experienced chauffeurs for a smooth travel experience."
  }
],
"tableData": [
  ["Online Cab Booking Navi Mumbai Airport", "Navi Mumbai Airport Online Cab Booking"],
  ["Book Cab Online Navi Mumbai Airport", "Navi Mumbai Airport Cab Booking Online"],
  ["Online Taxi Booking Navi Mumbai Airport", "Best Online Cab Booking Navi Mumbai Airport"],
  ["Cheap Online Cab Booking Navi Mumbai Airport", "Reliable Online Cab Booking Navi Mumbai Airport"],
  ["Instant Cab Booking Navi Mumbai Airport", "Advance Cab Booking Navi Mumbai Airport"],
  ["24x7 Online Cab Booking Navi Mumbai Airport", "Late Night Online Cab Booking Navi Mumbai Airport"],
  ["Early Morning Online Cab Booking Navi Mumbai Airport", "Airport Pickup Online Cab Booking Navi Mumbai"],
  ["Online Airport Transfer Navi Mumbai", ""]
],




whychoose: [
  {
    WhyChooseheading: "Easy Online Cab Booking at Navi Mumbai Airport",
    WhyChoosedescription: "Reserve your airport taxi online with Shreesha Travels for quick, convenient, and reliable transportation. Whether you are arriving or departing, our online booking process makes planning your journey simple and hassle-free."
  },
  {
    WhyChooseheading: "Instant Airport Cab Reservations",
    WhyChoosedescription: "Book your cab in advance for timely airport pickups and drops. Our team schedules your ride according to your travel details, ensuring a smooth transfer without last-minute arrangements."
  },
  {
    WhyChooseheading: "Wide Selection of Comfortable Vehicles",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles suitable for solo travellers, families, and corporate groups."
  },
  {
    WhyChooseheading: "Airport Transfers Across Mumbai & Beyond",
    WhyChoosedescription: "Our online cab booking service connects Navi Mumbai Airport with Mumbai, Navi Mumbai, Thane, Pune, Nashik, Lonavala, Surat, Ahmedabad, Goa, and numerous destinations across India."
  },
  {
    WhyChooseheading: "Ideal for Business, Family & Tourist Travel",
    WhyChoosedescription: "Whether you are travelling for business meetings, vacations, hotel transfers, educational visits, medical appointments, or family holidays, our airport taxi service is designed to suit every travel requirement."
  },
  {
    WhyChooseheading: "Professional Chauffeurs & Reliable Service",
    WhyChoosedescription: "Our experienced drivers provide courteous assistance, safe driving, and punctual airport transfers while choosing efficient routes for a comfortable journey."
  },
  {
    WhyChooseheading: "Well-Maintained & Sanitized Vehicles",
    WhyChoosedescription: "Every cab is regularly serviced, air-conditioned, sanitized, and inspected before every booking to provide passengers with a clean, safe, and enjoyable travel experience."
  },
  {
    WhyChooseheading: "Book Online Navi Mumbai Airport Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, quick booking confirmation, flexible travel options, and dependable chauffeur-driven airport transportation with Shreesha Travels."
  }
]

};

const faqData = [
  {
    question: "How can I book a cab online for Navi Mumbai Airport?",
    answer: "Simply share your travel date, flight details, pickup or drop location, passenger count, and preferred vehicle to complete your online booking."
  },
  {
    question: "Can I reserve an airport cab before my flight?",
    answer: "Yes, advance online booking is available for both airport pickups and airport drop services."
  },
  {
    question: "Which vehicles are available for online airport cab booking?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles."
  },
  {
    question: "Can I book a cab from Navi Mumbai Airport to another city online?",
    answer: "Yes, online bookings are available for destinations including Pune, Nashik, Lonavala, Surat, Ahmedabad, Goa, Kolhapur, and many other cities."
  },
  {
    question: "Do you provide online booking for corporate airport transfers?",
    answer: "Yes, our online airport cab booking service is suitable for executives, business visitors, employees, and corporate travel requirements."
  },
  {
    question: "Is online airport cab booking available 24 hours?",
    answer: "Yes, you can schedule airport cab bookings for any time of the day according to your flight schedule."
  },
  {
    question: "Can I choose a one-way or round-trip airport transfer online?",
    answer: "Yes, both one-way and round-trip airport transfer bookings are available with flexible travel plans."
  },
  {
    question: "How is the airport cab fare calculated?",
    answer: "The fare depends on the travel distance, selected vehicle, trip timing, tolls, parking charges, and additional travel requirements."
  },
  {
    question: "Will the driver contact me before pickup?",
    answer: "Yes, driver details and coordination are shared before your scheduled pickup for a smooth airport transfer."
  },
  {
    question: "Why should I choose Shreesha Travels for online cab booking at Navi Mumbai Airport?",
    answer: "Shreesha Travels offers punctual service, comfortable vehicles, professional chauffeurs, transparent pricing, and reliable airport transportation for every journey."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Darshan Patel",
    feedback: "The online booking process was quick and convenient. Our airport cab arrived on time, and the entire journey was comfortable and professionally managed.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Meenal Joshi",
    feedback: "Very easy online airport cab booking experience. The vehicle was clean, the driver was polite, and we reached our destination safely without any delays.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Cab Booking Navi Mumbai Airport",
  "image": "https://www.shreeshatravels.com/assets/images/online-cab-booking-navi-mumbai-airport.webp",
  "description":
    "Book Online Cab Booking Navi Mumbai Airport with Shreesha Tours & Travels for quick, safe, and reliable airport taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for airport pickup, airport drop, local travel, corporate travel, family trips, and outstation journeys with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/online-cab-booking-navi-mumbai-airport"
  }
};




    return (
        <div>
<Helmet>
  <title>Online Cab Booking Navi Mumbai Airport | Airport Taxi Booking | +91 8355835813</title>

  <meta
    name="description"
    content="Book Online Cab Booking Navi Mumbai Airport with Shreesha Travels for safe and comfortable airport taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for airport pickup, airport drop, local transfers, family travel, corporate travel, and 24x7 online cab booking."
  />

  <meta
    name="keywords"
    content="Online Cab Booking Navi Mumbai Airport, Navi Mumbai Airport Online Cab Booking, Book Cab Online Navi Mumbai Airport, Navi Mumbai Airport Cab Booking Online, Online Taxi Booking Navi Mumbai Airport, Best Online Cab Booking Navi Mumbai Airport, Navi Mumbai Airport Taxi Booking, Navi Mumbai Airport Cab Service, Airport Cab Booking Navi Mumbai, Online Airport Taxi Navi Mumbai"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Onlinecabbookingnavimumbaiairport;